import { useMemo, useState } from "react";
const useAddressPagination = (addresses, itemsPerPage) => {
  const [shippingAddressSearch, setShippingAddressSearch] = useState("");
  const [billingAddressSearch, setBillingAddressSearch] = useState("");
  const [currentShippingAddressPage, setCurrentShippingAddressPage] = useState(1);
  const [currentBillingAddressPage, setCurrentBillingAddressPage] = useState(1);
  const [loadingShippingAddressList, setLoadingShippingAddressList] = useState(false);
  const [loadingBillingAddressList, setLoadingBillingAddressList] = useState(false);
  const filteredShippingAddresses = useMemo(() => {
    if (!addresses || addresses.length === 0) return [];
    if (!shippingAddressSearch.trim()) return addresses;
    const searchTerm = shippingAddressSearch.toLowerCase().trim();
    return addresses.filter(address => address.firstname?.toLowerCase().includes(searchTerm) || address.lastname?.toLowerCase().includes(searchTerm) || address.address1?.toLowerCase().includes(searchTerm) || address.address2?.toLowerCase().includes(searchTerm) || address.city?.toLowerCase().includes(searchTerm) || address.postcode?.includes(searchTerm));
  }, [addresses, shippingAddressSearch]);
  const filteredBillingAddresses = useMemo(() => {
    if (!addresses || addresses.length === 0) return [];
    const addressesWithVat = addresses.filter(address_0 => address_0.vatNumber !== "");
    if (!billingAddressSearch.trim()) return addressesWithVat;
    const searchTerm_0 = billingAddressSearch.toLowerCase().trim();
    return addressesWithVat.filter(address_1 => address_1.firstname?.toLowerCase().includes(searchTerm_0) || address_1.lastname?.toLowerCase().includes(searchTerm_0) || address_1.address1?.toLowerCase().includes(searchTerm_0) || address_1.address2?.toLowerCase().includes(searchTerm_0) || address_1.city?.toLowerCase().includes(searchTerm_0) || address_1.postcode?.includes(searchTerm_0));
  }, [addresses, billingAddressSearch]);
  const paginatedShippingAddresses = useMemo(() => {
    const startIndex = (currentShippingAddressPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredShippingAddresses.slice(startIndex, endIndex);
  }, [filteredShippingAddresses, currentShippingAddressPage, itemsPerPage]);
  const paginatedBillingAddresses = useMemo(() => {
    const startIndex_0 = (currentBillingAddressPage - 1) * itemsPerPage;
    const endIndex_0 = startIndex_0 + itemsPerPage;
    return filteredBillingAddresses.slice(startIndex_0, endIndex_0);
  }, [filteredBillingAddresses, currentBillingAddressPage, itemsPerPage]);
  const totalShippingAddressPages = Math.ceil(filteredShippingAddresses.length / itemsPerPage);
  const totalBillingAddressPages = Math.ceil(filteredBillingAddresses.length / itemsPerPage);
  return {
    shippingAddressSearch,
    setShippingAddressSearch,
    billingAddressSearch,
    setBillingAddressSearch,
    currentShippingAddressPage,
    setCurrentShippingAddressPage,
    currentBillingAddressPage,
    setCurrentBillingAddressPage,
    loadingShippingAddressList,
    setLoadingShippingAddressList,
    loadingBillingAddressList,
    setLoadingBillingAddressList,
    filteredShippingAddresses,
    filteredBillingAddresses,
    paginatedShippingAddresses,
    paginatedBillingAddresses,
    totalShippingAddressPages,
    totalBillingAddressPages
  };
};
export default useAddressPagination;